import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ResultHeader } from './TimeSeriesChartResultHeader.style';

export type TimeSeriesChartResultHeaderProps = {
  targetName: string | undefined;
};

export function TimeSeriesChartResultHeader({ targetName }: TimeSeriesChartResultHeaderProps) {
  const { t } = useTranslation();

  return (
    <ResultHeader>
      <Typography variant="h6" color="text.primary" data-testid="time-series-chart-result-title">
        {t('timeSeriesChart.title')}
      </Typography>
      {targetName && (
        <Typography variant="h6" component="span" color="text.secondary" data-testid="time-series-chart-result-target">
          ({targetName})
        </Typography>
      )}
    </ResultHeader>
  );
}
